import { merge } from 'lodash';
import type { FormSchemaType } from './schema';

/**
 * État initial du formulaire vélo
 * @param data - Données initiales provenant de /init
 */
export default (data: FormSchemaType): FormSchemaType => {
    return merge(
        {
            // source: 'site', // Source par défaut
            DemandeTarif: {
                ActeGestion: 'AN', // Affaire nouvelle par défaut
                Police: {
                    CodeProduit: 'VeloAMO', // TODO: Vérifier le code produit exact
                    Canal: 'CB', // Canal par défaut
                    IdApporteur1: null,
                    FractionnementChoisi: 'M', // Mensuel par défaut
                    FormuleChoisie: 'F1',
                },
                Vehicule: {
                    FamilleProduit: 'Velo',
                    // GenreVehicule: undefined, // VEL, VAE, VELC
                    // Designation: undefined,
                    // ValeurVehicule: undefined,
                    // DateMEC: undefined,
                },
                DevoirConseil: {
                    // DevoirIC: undefined,
                },
                ListePersonnes: [
                    {
                        TypePersonne: 'P',
                        RoleConducteur: 'P',
                        Souscripteur: true,
                        DejaClient: false,
                    },
                ],
            },
            DemandeDevis: {
                // OptinRecontact: undefined,
            },
            DemandeContrat: {
                ModePaiementTerme: 'P', // P = Prélèvement
                Signature: true,
                SignatureMethod: 'sms',
                // DateHeureEffet: undefined,
            },
            // Champs spécifiques aux déclarations
            // declaration_vehicule: undefined, // Pour VAE/VELC
        } as FormSchemaType,
        data,
    );
};
